<template>
    <!-- Content Header (Page header) -->
    <div class="content-header">
        <div class="container-fluid">
            <div class="row mb-2">
                <div class="col-sm-6">
                    <h1 class="m-0">Solicitudes</h1>
                </div><!-- /.col -->
                <div class="col-sm-6">
                    <ol class="breadcrumb float-sm-right">
                        <li class="breadcrumb-item">
                            <router-link :to="{ name: 'home' }">
                                Home
                            </router-link>
                        </li>
                        <li class="breadcrumb-item active">Solicitudes</li>
                    </ol>
                </div><!-- /.col -->
            </div><!-- /.row -->
        </div><!-- /.container-fluid -->
    </div>
    <!-- /.content-header -->

    <!-- Main content -->
    <div class="content" id="section-tb-Solicitudes">
        <div class="container-fluid">
            <div class="row">
                <div class="col-lg-12">
                    <Card>
                        <template v-slot:header class="border-0">
                            <ul class="nav nav-tabs" id="custom-tabs-four-tab" role="tablist">
                                <!--PASO 1: TAB DE CARTA DE AUTORIZACIÓN DE REVISIÓN DE BURÓ DE CRÉDITO -->
                                <li class="nav-item">
                                    <a class="nav-link active" id="custom-tabs-list-authorization-bureau"
                                        data-toggle="pill" href="#custom-tabs-list-authorization-bureau" role="tab"
                                        aria-controls="custom-tabs-list-authorization-bureau" aria-selected="false"
                                        @click="bodyContent = 1">Autorización consulta de buró</a>
                                </li>
                                <!--PASO 2: TAB DE AVISO DE PRIVACIDAD -->
                                <li class="nav-item">
                                    <a class="nav-link" id="custom-tabs-list-privacy-policy" data-toggle="pill"
                                        href="#custom-tabs-list-privacy-policy" role="tab"
                                        aria-controls="custom-tabs-list-privacy-policy" aria-selected="false"
                                        @click="bodyContent = 2">Aviso de privacidad</a>
                                </li>
                                <!--PASO 3: TAB DE CONTRATO -->
                                <li class="nav-item">
                                    <a class="nav-link" id="custom-tabs-list-contract" data-toggle="pill"
                                        href="#custom-tabs-list-contract" role="tab"
                                        aria-controls="custom-tabs-list-contract" aria-selected="false"
                                        @click="bodyContent = 3">Contrato</a>
                                </li>
                                <!--PASO 4: TAB DE CARÁTULA ANEXO-->
                                <li class="nav-item">
                                    <a class="nav-link" id="custom-tabs-list-contract-cover" data-toggle="pill"
                                        href="#custom-tabs-list-contract-cover" role="tab"
                                        aria-controls="custom-tabs-list-contract-cover" aria-selected="false"
                                        @click="bodyContent = 4">Carátula</a>
                                </li>
                                <!--PASO 5: TAB DE AMORTIZACIÓN-->
                                <li class="nav-item">
                                    <a class="nav-link" id="custom-tabs-list-amortization" data-toggle="pill"
                                        href="#custom-tabs-list-amortization" role="tab"
                                        aria-controls="custom-tabs-list-amortization" aria-selected="false"
                                        @click="bodyContent = 5">Amortización</a>
                                </li>
                                <!--PASO 6: TAB DE PAGARE-->
                                <li class="nav-item">
                                    <a class="nav-link" id="custom-tabs-list-promissory-note" data-toggle="pill"
                                        href="#custom-tabs-list-promissory-note" role="tab"
                                        aria-controls="custom-tabs-list-promissory-note" aria-selected="false"
                                        @click="bodyContent = 6">Pagaré</a>
                                </li>
                                <!--PASO 7: TAB DE Solicitud de domiciliación Anexo D-->
                                <li class="nav-item">
                                    <a class="nav-link" id="custom-tabs-list-direct-debit" data-toggle="pill"
                                        href="#custom-tabs-list-direct-debit" role="tab"
                                        aria-controls="custom-tabs-list-direct-debit" aria-selected="false"
                                        @click="bodyContent = 7">Domiciliación Anexo D</a>
                                </li>
                            </ul>
                        </template>
                        <template v-slot:default>
                            <div class="tab-content w-100" id="custom-tabs-four-tabContent">
                                <!--PASO 1: VISTA DE CARTA DE AUTORIZACIÓN DE REVISIÓN DE BURÓ DE CRÉDITO -->
                                <div class="tab-pane fade active show" id="custom-tabs-list-authorization-bureau"
                                    role="tabpanel" aria-labelledby="custom-tabs-list-authorization-bureau">
                                    <ListAuthorizationBureau v-if="bodyContent === 1" />
                                </div>
                                <!--PASO 2: VISTA DE AVISO DE PRIVACIDAD -->
                                <div class="tab-pane fade active show" id="custom-tabs-list-privacy-policy"
                                    role="tabpanel" aria-labelledby="custom-tabs-list-privacy-policy">
                                    <ListPrivacyPolicy v-if="bodyContent === 2" />
                                </div>
                                <!--PASO 3: VISTA DE CONTRATO -->
                                <div class="tab-pane fade active show" id="custom-tabs-list-contract" role="tabpanel"
                                    aria-labelledby="custom-tabs-list-contract">
                                    <ListContract v-if="bodyContent === 3" />
                                </div>
                                <!--PASO 4: VISTA DE CARÁTULA ANEXO -->
                                <div class="tab-pane fade active show" id="custom-tabs-list-contract-cover"
                                    role="tabpanel" aria-labelledby="custom-tabs-list-contract-cover">
                                    <ListContractCover v-if="bodyContent === 4" />
                                </div>
                                <!--PASO 5: VISTA DE TABLA DE AMORTIZACIÓN  -->
                                <div class="tab-pane fade active show" id="custom-tabs-list-amortization"
                                    role="tabpanel" aria-labelledby="custom-tabs-list-amortization">
                                    <ListAmortization v-if="bodyContent === 5" />
                                </div>
                                <!--PASO 6: VISTA DE PAGARÉ -->
                                <div class="tab-pane fade active show" id="custom-tabs-list-promissory-note"
                                    role="tabpanel" aria-labelledby="custom-tabs-list-promissory-note">
                                    <ListPromissoryNote v-if="bodyContent === 6" />
                                </div>
                                <!--PASO 7: VISTA DE SOLICITUD DE DOMICILIACIÓN ANEXO D -->
                                <div class="tab-pane fade active show" id="custom-tabs-list-direct-debit"
                                    role="tabpanel" aria-labelledby="custom-tabs-list-direct-debit">
                                    <ListDirectDebit v-if="bodyContent === 7" />
                                </div>
                            </div>
                        </template>
                    </Card>
                    <!-- /.card -->
                </div>
            </div>
            <!-- /.row -->
        </div>
        <!-- /.container-fluid -->
    </div>
    <!-- /.content -->
</template>

<script>
import Tabs from '@/Components/Bootstrap/Tabs.vue';
import TabContent from '@/Components/Bootstrap/TabContent.vue';
import Card from '@/Components/Bootstrap/Card.vue';
import ListAuthorizationBureau from '@/Pages/LoanApplications/Legal/ListAuthorizationBureauConsultation.vue';
import ListPrivacyPolicy from '@/Pages/LoanApplications/Legal/ListPrivacyPolicy.vue';
import ListContract from './ListContract.vue';
import ListContractCover from './ListContractCover.vue';
import ListAmortization from './ListAmortization.vue';
import ListPromissoryNote from './ListPromissoryNote.vue';
import ListDirectDebit from './ListDirectDebit.vue';

export default {
    components: {
        Tabs,
        TabContent,
        Card,
        ListAuthorizationBureau,
        ListPrivacyPolicy,
        ListContract,
        ListContractCover,
        ListAmortization,
        ListPromissoryNote,
        ListDirectDebit
    },
    data() {
        return {
            /**Configuración del card */
            cardClasses: {
                header: 'border-0'
            },
            /**Configuración de los Tabs */
            tabs: [
                { name: 'Lista de Autorización consulta de buró', slot: 'authorization_bureaus' },
                { name: 'Lista de Aviso de privacidad', slot: 'privacy_policys' },
                { name: 'Lista de Contratos', slot: 'contract' },
                { name: 'Lista de Carátula', slot: 'contract_cover' },
                { name: 'Lista de Amortización', slot: 'amortization' },
                { name: 'Lista de Pagaré', slot: 'promissory_note' },
                { name: 'Lista de Solicitud de domiciliación Anexo D', slot: 'direct_debit' }
            ],
            activeTab: 0,
            bodyContent: 1,
        }
    },
    computed: {
    },
    methods: {
        handleTabSelected(index) {
            this.activeTab = index;
            this.$refs.tabContent.updateActiveTab(index);
        }
    },
    created() {
    },
    mounted() {
    }
}
</script>